import {Component, Input} from '@angular/core';
import {FormGroup, FormGroupDirective} from "@angular/forms";
import {DynamicFormModel} from "../../models/dynamic-form-model";
@Component({
  selector: 'ebw-monorepo-dynamic-checkboxs',
  templateUrl: './dynamic-checkboxs.component.html',
  styleUrls: ['./dynamic-checkboxs.component.scss']
})
export class DynamicCheckboxsComponent {
  @Input() field: DynamicFormModel;
  formName: FormGroup;
  constructor(private formgroupDirective: FormGroupDirective) {
    this.formName = formgroupDirective.control;
  }
}
